/* eslint-disable jsx-a11y/anchor-is-valid */
import Popover from "component/design-system/popover/Popover";
import PAText from "component/design-system/typography/PAText/PAText";
import withErrorHandler from "component/design-system/withErrorHandler";
import { DELIVERY_METHODS } from "constant/action-constants";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useSelector } from "react-redux";
import styles from "./bopis.module.scss";

function BOPISToolTip(props) {
  const { showhelpText = true } = props;
  const { t } = useTranslation("product");
  const shoppingCart = useSelector((state: RootState) => state.shoppingCart);
  const { availableDeliveryMethodsDetails } = shoppingCart;
  const pickupDetails = availableDeliveryMethodsDetails?.find((el) => el.deliveryMethod === DELIVERY_METHODS.PICKUP);
  const pickUpLocation = pickupDetails?.pickUpLocations?.[0];

  if (!pickUpLocation) {
    return null;
  }

  const { streetAddressLineOne, streetAddressLineTwo = ",", city } = pickUpLocation || {};

  return (
    <div>
      <Popover
        className={styles.popover_style}
        component={(
          <div className={styles.popover_content}>
            <i className="fa fa-map-marker" aria-hidden="true" />
            <div>
              <PAText bold>{`${t("Pickup address")}: `}</PAText>
              {`${streetAddressLineOne }${streetAddressLineTwo ? ` ${streetAddressLineTwo}` : ""}, ${city}`}
              {
                showhelpText && (
                  <PAText bold inlineBlock>
                    No other pickup location available within 500km of your postal code
                  </PAText>
                )
              }
            </div>
          </div>
        )}
        placement="top"
      >
        <div className={styles.popover_text}>
          <a className="pointer p-r-5">
            {pickUpLocation.name}
          </a>
          <i className="fa fa-info-circle more-info" />
        </div>
      </Popover>
    </div>
  );
}

export default withErrorHandler(BOPISToolTip);
